import { RegionManager } from 'backbone.marionette';

import { TransactionList } from '../../epayment/collections/transaction';
import TransactionView from '../views/transaction';


module.exports = function (options) {
  var regions = new RegionManager({
    regions: {
      transaction: '#transaction-hook'
    }
  });

  var transactionList = new TransactionList(
    [], {
      urlBase: options.transaction_url,
      search_params: {
        is_active: 'True',
        show_zero_value: 'False'
      }
    }
  );
  options.collection = transactionList;
  regions.get('transaction').show(new TransactionView(options));
  transactionList.fetch();
};



// WEBPACK FOOTER //
// ./parentpay/initializers/transaction.js